import { REQUEST_STATUSES, SORT_FIELD, SORT_ORIENTATION } from "@/constants/index.js";

import * as types from "./types.js";
import { ContentElementService } from "../../../services";

export const getContentElements = (propertyId, query) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_CONTENT_ELEMENTS_REQUEST_STATUS,
      payload: { propertyId, mediaItemId: query.mediaItemId || null, status: REQUEST_STATUSES.LOADING },
    });

    const { resp, status, err } = await ContentElementService.getContentElements(propertyId, query);

    dispatch({
      type: types.GET_CONTENT_ELEMENTS,
      payload: {
        propertyId,
        mediaItemId: query.mediaItemId || null,
        elements: resp?.data || [],
        status,
        err,
      },
    });
  };
};

export const refreshContentElements = (propertyId, mediaItemId, element) => {
  return async (dispatch) => {
    dispatch({
      type: types.REFRESH_CONTENT_ELEMENTS,
      payload: { propertyId, mediaItemId, element },
    });
  };
};

export const deleteContentElement = (propertyId, mediaItemId, elementId) => {
  return async (dispatch) => {
    await ContentElementService.deleteContentElement(propertyId, mediaItemId, elementId);

    dispatch({
      type: types.DELETE_CONTENT_ELEMENTS,
      payload: { elementId },
    });
  };
};

export const updateContentElement = (propertyId, mediaItemId, elementId, values) => {
  return async (dispatch) => {
    await ContentElementService.updateContentElement(propertyId, mediaItemId, elementId, values);

    dispatch(fetchAllContentElements(propertyId, mediaItemId));
  };
};

export const addContentElement = (propertyId, mediaItemId, values) => {
  return async (dispatch) => {
    await ContentElementService.addContentElement(propertyId, mediaItemId, values);

    dispatch(fetchAllContentElements(propertyId, mediaItemId));
  };
};

export const fetchAllContentElements = (propertyId, mediaItemId) => {
  return async (dispatch) => {
    const { resp, status, err } = await ContentElementService.getContentElements(propertyId, {
      sortField: SORT_FIELD.ELEMENT_CREATED_AT,
      sortOrientation: SORT_ORIENTATION.ASC,
    });

    const mediaItemElements = resp?.data?.filter((item) => item.mediaItemId === mediaItemId) || [];

    // we need to dispatch the content elements used in the current media item
    dispatch({
      type: types.GET_CONTENT_ELEMENTS,
      payload: {
        propertyId,
        mediaItemId,
        elements: mediaItemElements,
        status,
        err,
      },
    });

    // and we also need to dispatch the content elements used in the elements dialog
    dispatch({
      type: types.GET_CONTENT_ELEMENTS,
      payload: {
        propertyId,
        mediaItemId: null,
        elements: resp?.data || [],
        status,
        err,
      },
    });
  };
};
